module.exports = __webpack_public_path__ + "img/img2.36652252.png";